"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var UploadClientError = /** @class */ (function (_super) {
    __extends(UploadClientError, _super);
    function UploadClientError(message, request, response, headers) {
        var _this = _super.call(this) || this;
        _this.name = 'UploadClientError';
        _this.message = message;
        _this.request = request;
        _this.response = response;
        _this.headers = headers;
        Object.setPrototypeOf(_this, UploadClientError.prototype);
        return _this;
    }
    return UploadClientError;
}(Error));
exports.UploadClientError = UploadClientError;
exports.cancelError = function (message) {
    if (message === void 0) { message = 'Request canceled'; }
    var error = new UploadClientError(message);
    error.isCancel = true;
    return error;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@uploadcare/upload-client/lib/tools/errors.js
// module id = 90
// module chunks = 71